const GrayIcon = ({img, link}) => {
	return (
		<img className='grayIcon' src={img} />
	)
}

export default GrayIcon